<template>
    <transition name="slide-fade">
        <div class="modal" data-cy="modal_mission_alert" atm="mission-alert-modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content relative" 
                 :style="{ 
                    '--bg-alert-mission-url': 'url(' + bgAlertMission + ')',
                    '--bg-alert-mission-2-url': 'url(' + bgAlertMission2 + ')',
                    '--btn-alert-mission-url': 'url(' + btnAlertMission + ')',
                    '--btn-alert-mission-2-url': 'url(' + btnAlertMission2 + ')'
                 }">
                <div class="absolute top-1 left-0 right-0 z-50">
                    <img class="w-[95px] h-[88px] mx-auto" :src="imgJud" alt="icon jud">
                </div>
                <div class="absolute bottom-10 left-8 z-50">
                    <img class="w-[66px] h-[75px] mx-auto" :src="imgBottomLeft" alt="icon bottom left">
                </div>
                <div class="absolute bottom-10 right-8 z-50">
                    <img class="w-[66px] h-[75px] mx-auto" :src="imgBottomRight" alt="icon bottom left">
                </div>
                <div class="bg-alert-mission-2 relative mx-auto flex flex-col items-center justify-center">
                    <div class="text-center">
                        <div class="font-medium text-20">{{ title }}</div>
                        <div class="" v-html="message"></div>
                    </div>
                </div>
                <div class="absolute bottom-7 right-0 left-0 z-50 mx-auto text-center">
                    <button class="btn-alert-mission-2 font-medium text-25 text-center text-a-blue-f2f5ff mx-auto"
                        data-cy="btn_mission_alert_ok"
                        @click="clickOk()">
                        {{btnOk}}
                    </button>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import ConfigManager from "@/config/ConfigManager.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "MissionAlertModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,

            // Image URLs
            imgJud: null,
            imgBottomLeft: null,
            imgBottomRight: null,
            
            // Background Image URLs
            bgAlertMission: null,
            bgAlertMission2: null,
            btnAlertMission: null,
            btnAlertMission2: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.initImageUrls();
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.confirm_redeem.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.confirm_redeem.cancel;
            }

            this.controller.sendCallbackShow();

            document.body.classList.add('not-scroll');
            this.open = true;

        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        initImageUrls: function() {
            var appId = ConfigManager.getAppId();
            var baseUrl = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/`;
            
            // Icon images
            this.imgJud = baseUrl + 'image/modalconfirm/ic-jud.png';
            this.imgBottomLeft = baseUrl + 'image/modalconfirm/ic-bottom-left.png';
            this.imgBottomRight = baseUrl + 'image/modalconfirm/ic-bottom-right.png';
            
            // Background images
            this.bgAlertMission = baseUrl + 'image/mission/bg-mission-popup.png';
            this.bgAlertMission2 = baseUrl + 'image/modalconfirm/bg-confirm-play.png';
            this.btnAlertMission = baseUrl + 'image/mission/btn-mission-popup.png';
            this.btnAlertMission2 = baseUrl + 'image/mission/img-btn-v2.png';
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        overflow: unset;

        .modal-content {
            width: 420px;

            @include mobile {
                width: 100%;
                padding: 44px 20px;
            }
        }
        .btn {
            height: 50px;
        }
    }

    .bg-alert-mission{
        width: 295px;
        height: 167px;
        background-image: var(--bg-alert-mission-url);
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100% 167px;
    }

    .bg-alert-mission-2 {
        width: 340px;
        height: 192px;
        background-image: var(--bg-alert-mission-2-url);
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100% 192px;
    }

    .btn-alert-mission{
        width: 137px;
        height: 47px;
        background-image: var(--btn-alert-mission-url);
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100% 47px;
    }
    .btn-alert-mission-2{
        min-width: 182px;
        height: 55px;
        background-image: var(--btn-alert-mission-2-url);
        background-position: top center;
        background-repeat: no-repeat;
    }

</style>
